import _ from "lodash";
import { store } from "../../store";

export const permissions = {
    ADMIN_WEB_USER_MANAGEMENT: 1,
    ADMIN_WEB_DASHBOARD: 2,
    ADMINISTRATIVE_AREA_MANAGEMENT: 3,
    LOCATION_MANAGEMENT: 4,
    CATEGORY_MANAGEMENT: 5,
    TRAVALOUR_USER_MANAGEMENT: 6,
    TRAVALOUR_USER_POSTS: 7,        // trips, travel cards, articles
    SPAM_MANAGEMENT: 8,
    SYSTEM_SETTINGS_MANAGEMENT: 9,
    DEV_SETTINGS: 10,
    AMENITIES: 11
};

export const types = {
    VIEW_ONLY: 1,
    VIEW_AND_EDIT: 2,
    VIEW_EDIT_AND_DELETE: 3
}

export const checkAcl = (permission) => {
    const acl = store.getState().auth?.acl;
    let hasAccess = false;

    if (!!acl && acl.length > 0) {
        const userAccess = _.find(acl, { p: permission.p })
        if (!!userAccess) {
            if (!!userAccess.t && userAccess.t >= permission.t) {
                hasAccess = true;
            }
        }
    }

    return hasAccess;
}